import { render, staticRenderFns } from "./Product11-01-006-000011ogmmr.vue?vue&type=template&id=90a85e74"
import script from "./Product11-01-006-000011ogmmr.vue?vue&type=script&lang=js"
export * from "./Product11-01-006-000011ogmmr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90a85e74')) {
      api.createRecord('90a85e74', component.options)
    } else {
      api.reload('90a85e74', component.options)
    }
    module.hot.accept("./Product11-01-006-000011ogmmr.vue?vue&type=template&id=90a85e74", function () {
      api.rerender('90a85e74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/deposit/Product11-01-006-000011ogmmr.vue"
export default component.exports